import { useEffect } from 'react'
import { LayoutChangeEvent } from 'react-native'
import {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withSpring,
} from 'react-native-reanimated'
import cn from '@ui/utils/cn'
import { colors } from '@ui/colors'
import Typography from '@ui/typography'
import { leadingNone } from '@ui/typography/styles'
import { GuideLine, guidelines } from './helpers'
import Animated from 'react-native-reanimated'
import { useTranslation } from 'react-i18next'

interface Props {
  label: string | null
  index: number
  active: number
  onLayout: (event: LayoutChangeEvent) => void
}

const getState = (index: number, active: number) =>
  index === active ? 1 : Math.abs(active - index) === 1 ? 0 : -1

export default function LabelItem({ label, index, active, onLayout }: Props) {
  const { t } = useTranslation(['ui'])
  const animateActive = useSharedValue(getState(index, active))

  const styleActive = useAnimatedStyle(() => ({
    opacity: interpolate(animateActive.value, [-1, 0, 1], [0, 0.25, 1]),
  }))

  useEffect(() => {
    animateActive.set(withSpring(getState(index, active)))
  }, [active])

  return (
    <Animated.View
      className={'relative inset-0'}
      onLayout={onLayout}
      style={styleActive}
    >
      {guidelines && <GuideLine className="bg-red-500/50" />}
      {label && (
        <Typography
          variant="MDB"
          className={cn(leadingNone)}
          color={colors.black}
        >
          {t(label)}
        </Typography>
      )}
    </Animated.View>
  )
}
